import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLandshut() {
  return (
    <CityPageTemplate
      city="Landshut"
      slug="landshut"
      intro="Landshut als niederbayerische Residenzstadt – fürstliche Finanzberatung für jeden Geldbeutel."
      description="Unabhängige & digitale Finanzberatung für Landshut: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
